/***
 * This module is used to hold data of the global configuration of the school regarding the pagesbuilder
 *
 * ***/
import { RepositoryFactory } from 'src/api/repositories/RepositoryFactory';
import { DefaultGlobalStyles} from '../../../../author/pagesbuilder/components/global-styling/GlobalStyles';
import {SiteTemplateFactory} from "../../../../author/pagesbuilder/components/global-styling/GlobalStyles";
import Vue from 'vue';

const SiteTemplatesRepository = RepositoryFactory.get('siteTemplates');



export default {
    namespaced : true,
    state: {
        globalStyles : DefaultGlobalStyles,
        globalStylesPageContext: false,
        globalGeneratedStyles : '',
        fontsInjected: [],
        selectedAdvancedTextOption : { key : "" , type: ""}
    },
    getters: {
        getGlobalTypographyStyles: (state) => {
            return state.globalStyles.typography
        },
        getGlobalInputStyles: (state) => {
            return state.globalStyles.input
        },
        getGlobalColorStyles: (state) => {
            return state.globalStyles.colors
        },
        getGlobalFonts: (state) => {
            return state.globalStyles.fonts;
        }

    },
    actions : {
        setSelectedAdvancedTextOption ({commit} , payload) {
            commit('setSelectedAdvancedTextOption' , payload);
        },
        getGlobalConfig ({dispatch}) {
            return SiteTemplatesRepository.getTemplates().then( ({data}) => {
                return data.templates;
            })
        },
        updateGlobalStyles ( {commit , state, getters , rootState, rootGetters}) {
            if (state.globalStylesPageContext){
                commit('setGlobalStyles' , rootState.pages.pageData.style_config);
            } else {
                commit('setGlobalStyles' , rootGetters['siteTemplate/currentSiteTemplateStyle']);
            }
        },
        setGlobalStyles ( {commit}, payload) {
            commit('setGlobalStyles' , payload);
        },
        setGlobalStylesPageContext ( {commit, state, dispatch}, payload) {
            commit('setGlobalStylesPageContext' , payload);
            dispatch('pages/updatePageStyling');
            dispatch('updateGlobalStyles');
        },
        setGlobalGeneratedStyles ( {commit}, payload) {
            commit('setGlobalGeneratedStyles' , payload);
        },
        setGlobalTypographyStyles ( {commit}, payload) {
            commit('setGlobalTypographyStyles' , payload);
        },
        setGlobalInputStyles ( {commit}, payload) {
            commit('setGlobalInputStyles' , payload);
        },
        resetGlobalInputStyles ( {commit, dispatch, state}, payload) {
            return dispatch(
                "siteTemplate/getCurrentSiteTemplateSourceSettings",
                {},
                {root: true}
            ).then((settings) => {
                let inputs = copyJson(settings.styling.input);
                let mainTextFont = state.globalStyles.fonts[1];

                // Make sure
                Object.keys(inputs).forEach((className) => {
                    if (typeof inputs[className]['fontFamily'] !== "undefined") {
                        inputs[className]['fontFamily'] = mainTextFont;
                    }
                });

                commit('setGlobalInputStyles', inputs);
                return inputs;
            });
        },
        setGlobalColorStyles ( {commit}, payload) {
            commit('setGlobalColorStyles' , payload);
        },
        changeGlobalStylesConfig ( {commit} , payload) {
            if(payload == 'default'){
                return;
            }
            let newConfig = SiteTemplateFactory.get(payload);
            commit('setGlobalStyles', newConfig);
        },
        setGlobalFonts( {commit}, payload) {
            commit('setGlobalFonts', payload);
        },
        setGlobalFontsHeading( {commit}, payload) {
            commit('setGlobalFontsHeading', payload);
        },
        setGlobalFontsText( {commit}, payload) {
            commit('setGlobalFontsText', payload);
        }

    },
    mutations : {
        setSelectedAdvancedTextOption ( state , payload) {
            Vue.set(state , 'selectedAdvancedTextOption', payload);
        },
        setGlobalStyles( state, payload ) {
            state.globalStyles = {
                ...DefaultGlobalStyles,
                ...payload
            };
        },
        setGlobalStylesPageContext ( state, payload ) {
            state.globalStylesPageContext = payload;
        },
        setGlobalGeneratedStyles ( state, payload ) {
            state.globalGeneratedStyles = payload;
        },
        setGlobalTypographyStyles( state, payload) {
            Vue.set(state.globalStyles, 'typography', {
                ...state.globalStyles.typography,
                ...payload
            });
            // state.globalStyles.typography = {
            //     ...state.globalStyles.typography,
            //     ...payload
            // };
        },
        setGlobalInputStyles( state, payload) {
            state.globalStyles.input = {
                ...state.globalStyles.input,
                ...payload
            };
        },
        setGlobalColorStyles( state, payload) {
            state.globalStyles.colors = {
                ...state.globalStyles.colors,
                ...payload
            };
        },
        setGlobalFonts( state, payload) {
            state.globalStyles.fonts = copyJson(payload);

            // Update inputs and buttons when changing font
            let mainTextFont = state.globalStyles.fonts[1];
            Object.keys(state.globalStyles.input).forEach((className) => {
                if (typeof state.globalStyles.input[className]['fontFamily'] !== "undefined") {
                    Vue.set(state.globalStyles.input[className], 'fontFamily', mainTextFont);
                }
            });
        },
        setGlobalFontsHeading( state, payload) {
            state.globalStyles.fonts[0] = payload;
        },
        setGlobalFontsText( state, payload) {
            state.globalStyles.fonts[1] = payload;

            // Update inputs and buttons when changing font
            let mainTextFont = payload;
            Object.keys(state.globalStyles.input).forEach((className) => {
                if (typeof state.globalStyles.input[className]['fontFamily'] !== "undefined") {
                    Vue.set(state.globalStyles.input[className], 'fontFamily', mainTextFont);
                }
            });
        },


    }
}
